var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","small":"","id":"retrain-model-btn","loading":_vm.handlingRequest},on:{"click":_vm.requestModelRetraining}},[_vm._v(" Retrain Model ")])
}
var staticRenderFns = []

export { render, staticRenderFns }